import type { FilterColor } from "../../shared/types";

// Literal class strings — Tailwind only generates classes it can see.
export const BADGE_CLASSES: Record<FilterColor, string> = {
  amber: "bg-amber-100 text-amber-800",
  blue: "bg-blue-100 text-blue-800",
  green: "bg-green-100 text-green-800",
  red: "bg-red-100 text-red-800",
  purple: "bg-purple-100 text-purple-800",
  gray: "bg-gray-200 text-gray-700",
};

// Solid, high-contrast variants for "important" badges (e.g. an Urgent filter),
// so they read as a strong signal instead of a faint pastel pill.
export const STRONG_BADGE_CLASSES: Record<FilterColor, string> = {
  amber: "bg-amber-500 text-white",
  blue: "bg-blue-600 text-white",
  green: "bg-green-600 text-white",
  red: "bg-red-600 text-white",
  purple: "bg-purple-600 text-white",
  gray: "bg-gray-600 text-white",
};

export const SWATCH_CLASSES: Record<FilterColor, string> = {
  amber: "bg-amber-400",
  blue: "bg-blue-500",
  green: "bg-green-500",
  red: "bg-red-500",
  purple: "bg-purple-500",
  gray: "bg-gray-400",
};

export const FILTER_COLORS = Object.keys(BADGE_CLASSES) as FilterColor[];

export function badgeClass(color: string): string {
  return BADGE_CLASSES[color as FilterColor] ?? BADGE_CLASSES.gray;
}

export function strongBadgeClass(color: string): string {
  return STRONG_BADGE_CLASSES[color as FilterColor] ?? STRONG_BADGE_CLASSES.gray;
}

/**
 * A red filter (e.g. "Urgent") marks a message as important — it should stand
 * out, not be dimmed like a routine category (Ads, Invoices).
 */
export function isImportantColor(color: string): boolean {
  return color === "red";
}

/** Pseudo-filter id for "messages with no badge" toggles. */
export const OTHER_FILTER_ID = -1;
